import React from 'react';

const DIAS_ES = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
const MESES_ES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

const extraerFecha = (fecha) => {
  if (!fecha) return null;
  const texto = String(fecha);
  const iso = texto.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    return { year: Number(iso[1]), month: Number(iso[2]), day: Number(iso[3]) };
  }

  const parsed = new Date(texto);
  if (Number.isNaN(parsed.getTime())) return null;
  return {
    year: parsed.getUTCFullYear(),
    month: parsed.getUTCMonth() + 1,
    day: parsed.getUTCDate(),
  };
};

const formatearFechaEs = (fecha) => {
  const partes = extraerFecha(fecha);
  if (!partes) return 'N/A';
  const fechaLocal = new Date(partes.year, partes.month - 1, partes.day);
  const diaSemana = DIAS_ES[fechaLocal.getDay()];
  const mes = MESES_ES[partes.month - 1];
  const dia = String(partes.day).padStart(2, '0');
  return `${diaSemana}, ${dia} ${mes} ${partes.year}`;
};

const diasDesdeFecha = (fecha) => {
  const partes = extraerFecha(fecha);
  if (!partes) return null;

  const fechaRevision = new Date(partes.year, partes.month - 1, partes.day);
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  return Math.floor((hoy - fechaRevision) / (1000 * 60 * 60 * 24));
};

const fechaUltimoExpediente = (numeroExpediente) => {
  if (!Array.isArray(numeroExpediente) || numeroExpediente.length === 0) return null;
  const ultimo = numeroExpediente[numeroExpediente.length - 1];
  return Array.isArray(ultimo) && ultimo.length > 1 ? ultimo[1] : null;
};

const RenderPatenteTabla = ({ patentes, onClickFila, mostrarFechaCreacion = false, mostrarFechaTramitacion = false, mostrarRevisionEstado = false }) => {
  return (
    <table>
      <thead>
        <tr>
          {mostrarFechaCreacion && <th>Fecha Creación</th>}
          {mostrarFechaTramitacion && <th>Fecha de tramitación</th>}
          {mostrarRevisionEstado && <th>Revisión Estado</th>}
          {mostrarRevisionEstado && <th>Días</th>}
          <th>RUT</th>
          <th>Razón Social</th>
          <th>Correo</th>
          <th>Estado</th>
          <th>Código</th>
          <th>N° Expediente</th>
          <th>Comentarios</th>
        </tr>
      </thead>
      <tbody>
        {patentes.map(patente => (
          <tr 
            key={patente.id} 
            onClick={() => onClickFila && onClickFila(patente)} 
            style={{
              cursor: onClickFila ? 'pointer' : 'default',
              fontSize: '12px',
              backgroundColor: patente.comunaPatente === 'Providencia' ? '#00F0FF' : patente.comunaPatente === 'Santiago' ? '#39FF14' : '#39FF14'
            }}
          >
            {mostrarFechaCreacion && (
              <td>{formatearFechaEs(patente.fechaCreacion)}</td>
            )}
            {mostrarFechaTramitacion && (
              <td>{formatearFechaEs(fechaUltimoExpediente(patente.numeroExpediente))}</td>
            )}
            {mostrarRevisionEstado && (
              <td>{formatearFechaEs(patente.revisionEstado)}</td>
            )}
            {mostrarRevisionEstado && (
              <td>{diasDesdeFecha(patente.revisionEstado) ?? 'N/A'}</td>
            )}
            <td>{patente.rut}</td>
            <td>{patente.razonSocial}</td>
            <td>{patente.correo}</td>
            <td>{patente.estado}</td>
            <td>{patente.codigo && patente.codigo.length > 0 ? patente.codigo[patente.codigo.length - 1][0] : 'N/A'}</td>
            <td>{patente.numeroExpediente && patente.numeroExpediente.length > 0 ? patente.numeroExpediente[patente.numeroExpediente.length - 1][0] : 'N/A'}</td>
            <td>{patente.terminoComentarios || 'N/A'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default RenderPatenteTabla;
